export default __webpack_public_path__ + "static/media/laudo2.abbcc78d.jpg";